import React, { useMemo, useEffect, useState } from 'react';

// DEPENDENCIES
import sumBy from 'lodash/sumBy';
import { useFormikContext } from 'formik';

// VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INVENTORY_SOURCE_IDS } from '../../../../../sections/variables';

// HELPERS/FUNCTIONS
import { apiFetch, makePath } from 'functions.js';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';
import Card from 'parts/card/Card';

// LOCAL COMPONENTS
import InputAppendCol from 'routers/interface/sections/parts/InputAppendCol';

//STYLES
import styles from '../../inventoryInternal.module.scss';

// MAIN COMPONENT
const InventoryInternalForm = ({ index }) => {
    // STATE
  const [inventoryDealerPack, setInventoryDealerPack] = useState([]);

  // CONTEXT
  const { values } = useFormikContext() || {};

  const inventoryPackTotal = useMemo(() => {
    return sumBy(inventoryDealerPack, 'pack_amount');
  }, [inventoryDealerPack]);

  const invoiceCostWithInventoryPack = useMemo(() => {
    const total = inventoryPackTotal + +(values?.aryTrade?.[index]?.inventory?.invoice_cost || 0);
    return total;
  }, [inventoryPackTotal, values, index]);

  useEffect(() => {
    apiFetch({
      endpoint: makePath(ENDPOINTS.inventory.package, INVENTORY_SOURCE_IDS.DEALER_DX),
      params: {
        newUsed: 1
      },
      onSuccess: data => setInventoryDealerPack(data?.result || []),
      loadingMessage: 'Loading Inventory Packages',
      errorMessage: 'Unable to get Inventory Packages.'
    });
  }, []);

  return (
    <Form.Body className={styles.body} fullWidth>
      <Form.PlainText
        label={{
          label: 'Factory Invoice Cost',
          className: 'fw-bolder'
        }}
        value={values?.aryTrade?.[index]?.inventory?.invoice_cost || 0}
        schema="dollars"
        formGroup={{ 
          className: styles.sideField
        }}
        input={{
          append: <InputAppendCol className="fw-bolder">Account to Credit</InputAppendCol>
        }}
      />
      {inventoryDealerPack?.length &&
        inventoryDealerPack.map((v, i) => (
          <Form.PlainText
            key={`${v.inventory_pack_id}-${i}`}
            label={`Inventory Pack ${i + 1}`}
            value={v.pack_amount}
            schema="dollars"
            formGroup={{ 
              className: styles.sideField
            }}
            input={{
              append: (
                <>
                  <InputAppendCol cols={{ sm: 12 }}>{v.pack_account_to_credit}</InputAppendCol>
                  <InputAppendCol cols={{ sm: 12 }}>{v.pack_title}</InputAppendCol>
                </>
              )
            }}
          />
        ))}
      <Form.PlainText
        label={{ label: 'Inventory Pack Total', className: 'fw-bolder' }}
        vertical
        value={inventoryPackTotal}
        schema="dollars"
      />
      <Form.PlainText
        label={{ label: 'Factory Invoice with Inventory Pack Total', className: 'fw-bolder' }}
        value={invoiceCostWithInventoryPack || values?.aryTrade?.[index]?.inventory?.invoice_cost}
        vertical
        schema="dollars"
      />
    </Form.Body>
  );
};

// EXPORT
export default function InventoryInternal(props) {
  return <Card title="Inventory - Internal" body={<InventoryInternalForm {...props} />} />;
}
